import React from 'react';
import Card from '../../ui/Card';
const CampaignFunnelChart: React.FC = () => {
  const funnelData = [{
    stage: 'Reach',
    value: 4850000,
    percentage: 100,
    color: 'bg-blue-500',
    displayValue: '48.5L'
  }, {
    stage: 'Impressions',
    value: 3240000,
    percentage: 67,
    color: 'bg-blue-600',
    displayValue: '32.4L'
  }, {
    stage: 'Engagement',
    value: 485000,
    percentage: 10,
    color: 'bg-green-500',
    displayValue: '4.85L'
  }, {
    stage: 'Leads',
    value: 97000,
    percentage: 2,
    color: 'bg-green-600',
    displayValue: '97K'
  }, {
    stage: 'Qualified Leads',
    value: 38800,
    percentage: 0.8,
    color: 'bg-yellow-500',
    displayValue: '38.8K'
  }, {
    stage: 'Deals',
    value: 13580,
    percentage: 0.28,
    color: 'bg-yellow-600',
    displayValue: '13.6K'
  }];
  return <Card className="p-6" data-id="element-6755">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6756">
        Campaign Conversion Funnel
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-6757">Journey from Reach to Deals</p>
      <div className="space-y-3 py-4" data-id="element-6758">
        {funnelData.map((stage, index) => <div key={index} className="relative" data-id="element-6759">
            <div className="flex items-center justify-between mb-2" data-id="element-6760">
              <div className="flex items-center" data-id="element-6761">
                <span className="text-sm font-medium text-gray-700" data-id="element-6762">
                  {stage.stage}
                </span>
                {index > 0 && <span className="ml-2 text-xs text-gray-500" data-id="element-6763">
                    (
                    {(stage.value / funnelData[index - 1].value * 100).toFixed(1)}
                    % conversion)
                  </span>}
              </div>
              <span className="text-sm font-semibold text-gray-800" data-id="element-6764">
                {stage.displayValue}
              </span>
            </div>
            <div className="relative h-12 bg-gray-100 rounded-lg overflow-hidden" data-id="element-6765">
              <div className={`h-full ${stage.color} flex items-center justify-between px-4 transition-all duration-500`} style={{
            width: `${Math.max(stage.percentage, 5)}%`
          }} data-id="element-6766">
                <span className="text-white font-medium text-sm" data-id="element-6767">
                  {stage.percentage >= 1 ? `${stage.percentage.toFixed(1)}%` : `${stage.percentage.toFixed(2)}%`}
                </span>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6768">
        <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-6769">
          <div className="text-center" data-id="element-6770">
            <div className="text-gray-600" data-id="element-6771">Overall Conversion</div>
            <div className="text-xl font-bold text-green-600" data-id="element-6772">2.8%</div>
          </div>
          <div className="text-center" data-id="element-6773">
            <div className="text-gray-600" data-id="element-6774">Lead Quality</div>
            <div className="text-xl font-bold text-yellow-600" data-id="element-6775">40%</div>
          </div>
          <div className="text-center" data-id="element-6776">
            <div className="text-gray-600" data-id="element-6777">Deal Close Rate</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-6778">35%</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default CampaignFunnelChart;